export const isAgentConversation = (conversation) =>
  conversation?.kind === 'agent'
  || conversation?.is_agent === true
  || conversation?.other_participant?.is_system === true;

const AGENT_OBJECT_TYPES = ['patient', 'admission'];

export const isAgentObjectConversation = (conversation) =>
  isAgentConversation(conversation)
  && AGENT_OBJECT_TYPES.includes(conversation?.object_type);

export const isCompletedAssistantThread = (conversation) =>
  isAgentObjectConversation(conversation) && conversation?.status === 'closed';

export const isDismissibleAssistantThread = (conversation) =>
  isAgentObjectConversation(conversation) && conversation?.status !== 'closed';

export const isTaskConversation = (conversation) => {
  if (isAgentConversation(conversation)) return false;
  if (conversation?.kind) return conversation.kind === 'task';
  return ['patient', 'admission', 'bill'].includes(conversation?.object_type);
};
